import {Zone} from "../../../domain";
import Api from "../../../services/api.service";
import {routes} from "../../../services/api.routes";

export const getAction = (id: string): Promise<Zone> => {
    return Api.$<Zone>(routes.zones).get(id)
}
